import { createHistory, useBasename }  from 'history';
import { Router, useRouterHistory }    from 'react-router';
import { settings } from 'app/globals';

export const browserHistory = useRouterHistory(createHistory)({
    basename: settings.basename
});